import React, { useEffect, useState } from "react";
import axios from "../../../axiosConfig";
import "./BookUpload.css";

const SubmitReview = () => {
  const [books, setBooks] = useState([]);
  const [formData, setFormData] = useState({
    book_id: "",
    subject: "",
    description: "",
  });
  const [files, setFiles] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const res = await axios.get("/books", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setBooks(res.data.books || []);
      } catch (err) {
        console.error("Failed to fetch books", err);
        setErrorMsg("Could not load your books. Please refresh and try again.");
      }
    };
    fetchBooks();
  }, []);

  const handleChange = (e) => {
    const { name, value, files: fileList } = e.target;
    if (name === "review_files") {
      setFiles(Array.from(fileList || []));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");
    setSubmitting(true);

    try {
      const payload = new FormData();
      payload.append("book_id", formData.book_id || "0");
      payload.append("subject", formData.subject);
      payload.append("description", formData.description);
      files.forEach((file) => payload.append("review_files", file));

      const res = await axios.post("/reviews", payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccessMsg(`Review submitted successfully${res.data.review_id ? ` (ID ${res.data.review_id})` : ""}.`);
      setFormData({ book_id: "", subject: "", description: "" });
      setFiles([]);
      e.target.reset?.();
    } catch (err) {
      console.error("Failed to submit review", err);
      setErrorMsg(err.response?.data?.error || "Failed to submit review. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bu-page">
      <div className="page-head">
        <div>
          <h1 className="page-title">Books Upload</h1>
          <p className="page-desc">
            Share feedback, notes, or supporting files for a book in your library.
          </p>
        </div>
      </div>

      <div className="panel bu-panel">
        <div className="panel-head">
          <span className="panel-title">Submit a review</span>
        </div>

        <div className="bu-panel-body">
          {successMsg ? <div className="bu-alert bu-alert-success">{successMsg}</div> : null}
          {errorMsg ? <div className="bu-alert bu-alert-error">{errorMsg}</div> : null}

          <form className="bu-form" onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="bu-book">Book</label>
              <select
                id="bu-book"
                className="text-input"
                name="book_id"
                value={formData.book_id}
                onChange={handleChange}
              >
                <option value="">General</option>
                {books.map((book) => (
                  <option key={book.book_id} value={book.book_id}>
                    {book.title}
                  </option>
                ))}
              </select>
              <span className="bu-hint">Choose a specific title, or leave as General.</span>
            </div>

            <div className="field">
              <label htmlFor="bu-subject">Subject</label>
              <input
                id="bu-subject"
                className="text-input"
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Short subject line"
                required
              />
            </div>

            <div className="field">
              <label htmlFor="bu-description">Description</label>
              <textarea
                id="bu-description"
                className="text-input bu-textarea"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Describe your review, notes, or request…"
                rows={6}
                required
              />
            </div>

            <div className="field">
              <label htmlFor="bu-files">Optional files</label>
              <label htmlFor="bu-files" className="bu-file-drop">
                <input
                  id="bu-files"
                  type="file"
                  name="review_files"
                  accept=".pdf,.zip,.jpg,.jpeg,.png"
                  multiple
                  onChange={handleChange}
                />
                <span className="bu-file-title">
                  {files.length
                    ? `${files.length} file${files.length === 1 ? "" : "s"} selected`
                    : "Choose files"}
                </span>
                <span className="bu-file-sub">PDF, ZIP, JPG, or PNG</span>
              </label>
              {files.length > 0 ? (
                <ul className="bu-file-list">
                  {files.map((file) => (
                    <li key={`${file.name}-${file.size}`}>{file.name}</li>
                  ))}
                </ul>
              ) : null}
            </div>

            <div className="bu-actions">
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? "Submitting…" : "Submit review"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubmitReview;
